// extracted by mini-css-extract-plugin
module.exports = {"list":"ListIconBox_list__oFpcO","rotation":"ListIconBox_rotation__bK0ii","preventivoBoxBubble":"ListIconBox_preventivoBoxBubble__z9om9"};